import React from "react"
import styled from "@emotion/styled"

type Variant = "white" | "primary"

const Shape = styled.div<{ variant: Variant }>`
  display: inline-block;
  padding: 0 8px;
  background: ${(props) =>
    props.variant === "white"
      ? props.theme.palette.surface.neutral.default
      : props.theme.palette.surface.secondary.strong};
  color: ${(props) =>
    props.variant === "white"
      ? props.theme.palette.content.secondary.default
      : props.theme.palette.content.neutral.inverse};
  border-radius: 8px;
  min-width: 16px;
  height: 16px;
  min-height: 16px;
  line-height: 16px;
  text-align: center;
  font-size: 12px;
`

interface BadgeProps extends React.HTMLAttributes<HTMLDivElement> {
  char?: string | number
  variant: Variant
}

const Badge = ({ char, variant, className, ...props }: BadgeProps) => (
  <Shape className={className} variant={variant} {...props}>
    {char}
  </Shape>
)

export default styled(Badge)``
